import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "@/components/Layout";
import Login from "@/views/Login";
import appDownload from "@/views/appDownload";

import authredirect from "@/views/authredirect";

Vue.use(VueRouter);
const VueRouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch((err) => err);
};
const routes = [
  {
    path: "/",
    redirect: { name: "Login" },
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/newyear",
    name: "newyear",
    component: () => import("@/views/new-year/index.vue"),
  },
  {
    path: "/authorization",
    name: "authorization",
    component: authredirect,
  },
  {
    path: "/pc",
    name: "pc",
    redirect: { path: "pc/index" },
    component: () => import("../views/pc/pc-header.vue"),
    children: [
      {
        path: "index",
        component: () => import("../views/pc"),
      },
      {
        path: "News",
        component: () => import("../views/pc/News.vue"),
      },
      {
        path: "Help",
        component: () => import("../views/pc/Help.vue"),
      },
      {
        path: "Adult",
        component: () => import("../views/pc/Adult"),
      },
      {
        path: "NewsDetail",
        component: () => import("../views/pc/NewsDetail"),
      },
    ],
  },
  {
    path: "/appDownload",
    name: "AppDownload",
    component: appDownload,
  },
  {
    path: "/news",
    name: "News",
    component: () => import("../views/News.vue"),
  },
  {
    path: "/newyear-news",
    name: "newyear-news",
    component: () => import("../views/new-year/News.vue"),
  },
  {
    path: "/newsDetail",
    name: "NewsDetail",
    component: () => import("../views/NewsDetail.vue"),
  },
  {
    path: "/newyear-detail",
    name: "newyear-detail",
    component: () => import("../views/new-year/NewsDetail.vue"),
  },
  {
    path: "/download",
    name: "Download",
    component: () => import("../views/Download.vue"),
  },
  {
    path: "/help",
    name: "Help",
    component: () => import("../views/Help.vue"),
  },
  {
    path: "/poster",
    name: "poster",
    component: () => import("../views/Poster"),
  },
  {
    path: "/newyear-help",
    name: "newyear-help",
    component: () => import("../views/new-year/Help.vue"),
  },
  {
    path: "/adult",
    name: "Adult",
    component: () => import("../views/Adult.vue"),
  },
  {
    path: "/newyear-adult",
    name: "newyear-adult",
    component: () => import("../views/new-year/Adult.vue"),
  },
  {
    path: "/orderPayment",
    name: "orderPayment",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/OrderPayment.vue"),
  },
  {
    path: "/main",
    component: Layout,
    redirect: { name: "home" },
    children: [
      {
        path: "home",
        name: "home",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/Home.vue"),
      },
      {
        path: "message",
        name: "message",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/message.vue"),
      },
      {
        path: "readyExam",
        name: "readyExam",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/ReadyExam.vue"),
      },
      {
        path: "watchCourseware",
        name: "watchCourseware",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/WatchCourseware.vue"
          ),
      },
      {
        path: "order",
        name: "order",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/Order.vue"),
      },
      {
        path: "course",
        name: "course",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/Course.vue"),
      },
      {
        path: "homework",
        name: "homework",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/Homework.vue"),
      },
      {
        path: "myHomework",
        name: "myHomework",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/MyHomework.vue"),
      },
      {
        path: "notSpecialtyCourse",
        name: "notSpecialtyCourse",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/notSpecialtyCourse.vue"
          ),
      },
      {
        path: "study",
        name: "study",
        props: { newsletterPopup: false },
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/Study.vue"),
      },
      {
        path: "study-gk",
        name: "study-gk",
        props: { newsletterPopup: false },
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/study-gk.vue"),
      },
      {
        path: "exam",
        name: "exam",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/Exam.vue"),
      },
      {
        path: "resitApply",
        name: "resitApply",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/ResitApply.vue"),
      },
      {
        path: "thesis",
        name: "thesis",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/Thesis.vue"),
      },
      {
        path: "score",
        name: "score",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/Score.vue"),
      },
      {
        path: "exemption",
        name: "exemption",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/exemption.vue"),
      },
      {
        path: "degree",
        name: "degree",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/degree.vue"),
      },
      {
        path: "excellent",
        name: "excellent",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/Excellent.vue"),
      },
      {
        path: "grad",
        name: "grad",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/Grad.vue"),
      },
      {
        path: "profile",
        name: "profile",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/Profile.vue"),
      },
      {
        path: "examination",
        name: "examination",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/Examination.vue"),
      },
      {
        path: "myOrder",
        name: "myOrder",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/MyOrder.vue"),
      },
      {
        path: "register",
        name: "register",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/Register.vue"),
      },

      // 论文
      {
        path: "thesis2",
        name: "thesis2",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/thesis/index.vue"),
      },
      {
        path: "addThesisProposal",
        name: "addThesisProposal",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/thesis/thesisproposal2/addThesisProposal.vue"
          ),
      },
      {
        path: "myThesisProposal",
        name: "myThesisProposal",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/thesis/thesisproposal2/myThesisProposal.vue"
          ),
      },
      {
        path: "mySpotCheck",
        name: "mySpotCheck",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/thesis/mySpotCheck.vue"
          ),
      },
      {
        path: "updateThesisProposal",
        name: "updateThesisProposal",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/thesis/thesisproposal2/updateThesisProposal.vue"
          ),
      },
      {
        path: "onlineDefenseList",
        name: "onlineDefenseList",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/thesis/OnlineDefenseList.vue"
          ),
      },
    ],
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Study.vue"),
  },
  {
    path: "/thesis-edit",
    name: "ThesisEdit",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/thesis/ThesisEdit.vue"),
  },
  {
    path: "/db-waiting-area",
    name: "DbWaitingArea",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/thesis/dbWaitingArea.vue"
      ),
  },
  {
    path: "/online-defense-room",
    name: "OnlineDefenseRoom",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/thesis/Room.vue"
      ),
  },
];

const router = new VueRouter({
  // mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (to.name !== "Login" && !window.sessionStorage.getItem("token")) {
    const arr = [
      "poster",
      "authorization",
      "AppDownload",
      "News",
      "NewsDetail",
      "Download",
      "Help",
      "Adult",
      "newyear",
      "newyear-news",
      "newyear-detail",
      "newyear-help",
      "newyear-adult"
    ];
    console.log(arr.indexOf(to.name) !== -1);
    if (arr.indexOf(to.name) !== -1) {
      next();
    } else {
      next("Login");
    }
  } else {
    next();
  }
});

export default router;
